<template>
  <div class="usp" v-bind:class="{ 'usp--spaced': extraSpace }">
    <ul class="usp__list" :class="{ 'usp__list--horizontal': displayHorizontally }">
      <li class="usp__item" :class="{ 'usp__item--horizontal': displayHorizontally }" v-for="item in uniqueSellingPoints" :key="item.id" >
        <img class="usp__image" :src="item.image" />
        <div class="usp__text">
          <strong>{{item.header}}</strong>
          <span class="usp__description">
            {{item.description}}
          </span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import {
  Component,
  Prop,
  Provide,
  Vue,
  Watch
} from 'vue-property-decorator';
import UniqueSellingPoint from '../../models/UniqueSellingPoint';

@Component
export default class USPComponent extends Vue {
  @Prop({ default: false })
  public displayHorizontally!: boolean;

  @Prop({
    default: () => [
      new UniqueSellingPoint(
        1,
        'Your details are safe',
        'We don’t disclose your details to any dealers until you tell us.',
        `${process.env.BASE_URL}images/success.svg`
      ),
      new UniqueSellingPoint(
        2,
        'Save Money',
        'We scan 1000’s of prices to find you savings on your new car.',
        `${process.env.BASE_URL}images/success.svg`
      ),
      new UniqueSellingPoint(
        3,
        'Hassle-free',
        'Get prices in just a couple of clicks.',
        `${process.env.BASE_URL}images/success.svg`
      )]
  })
  public uniqueSellingPoints!: UniqueSellingPoint[];

  @Prop({ default: false })
  public extraSpace!: boolean;
}
</script>
